var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"item"},[(_vm.components)?_c('render-content',{attrs:{"content":_vm.components}}):_vm._e(),_vm._v(" "),(_vm.note)?_c('p',{staticClass:"item__note"},[_vm._v(_vm._s(_vm.note))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }